import styled from '@emotion/styled';
import Head from 'next/head';
import { Home, Nav } from '../components';

const StyledPage = styled.div``;

export function HomePage() {
  return (
    <StyledPage>
      <Head>
        <title>Video | Chat</title>
      </Head>
      <Nav />
      <main className="w-full">
        <Home />
      </main>
    </StyledPage>
  );
}

export default HomePage;
